import { render, staticRenderFns } from "./FcConversation.vue?vue&type=template&id=25f955f5&scoped=true"
import script from "./FcConversation.vue?vue&type=script&lang=js"
export * from "./FcConversation.vue?vue&type=script&lang=js"
import style0 from "./FcConversation.vue?vue&type=style&index=0&id=25f955f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f955f5",
  null
  
)

export default component.exports